import React from "react";
import LoadingGif from "../../Images/trifecta-loading.gif";
import { myUtilities } from "../../Utils";
class StaticLoader extends React.Component {
  render() {
    return (
      <div className="centered-container static-loader">
        <div>
          <img src={LoadingGif} />
          <div className="loading-text">
            {myUtilities.accountSpecificLanguage("Loading", "Loading")}
          </div>
        </div>
      </div>
    );
  }
}

export default StaticLoader;
